export default __webpack_public_path__ + "static/media/menuEditarCard.173557a3.svg";